import { List } from 'immutable';

export const waitlistEventFull = (event, tickets = List()) => {
  const rsvpAtCapacity =
    event.get('enable_waitlist') && event.get('event_setup') === 'rsvp' && !event.get('unlimited_capacity') && event.get('available_capacity') === 0;
  const ticketsNoCapacity = event.get('event_setup') === 'tickets' && tickets.every((ticket) => ticket.get('available_quantity') === 0);
  return rsvpAtCapacity || (ticketsNoCapacity && event.get('enable_waitlist') && event.get('waitlist_trigger_event_capacity'));
};

export const waitlistTicketSoldout = (event, ticket) => {
  const ticketSoldout = ticket.get('available_quantity') === 0;
  return ticketSoldout && event.get('enable_waitlist') && event.get('waitlist_trigger_tickets_sold_out');
};
